import React, { Fragment } from 'react'
import { Grid, Box, Typography, Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useResponsive } from '../../../hooks/use-responsive';
import { useNavigate } from 'react-router-dom';
import { paths } from "../../../routes/paths.js";


function ReferAndEarnHero() {
    const mdUp = useResponsive("up", "md");
    const navigate = useNavigate();
    const GetReferralCode = styled(Button)(({ theme }) => ({
        backgroundColor: "#C7F760",
        color: "#1E53E8",
        fontFamily: "Roboto Flex",
        fontSize: "18px",
        fontWeight: 700,
        textTransform: "none",
        boxShadow: "none",
        "& .icon-hover": {
            transition: "color 0.3s ease",
        },
        "&:hover": {
            backgroundColor: "#2020ff",
            color: "#C7F760",
            transform: "scale(1.05)",
        },
    
          "&:active": {
            backgroundColor: "#2020ff",
            transform: "scale(1)",
          },
    }));
    const handleReferralClick = () => {
        const accessToken = localStorage.getItem('accessToken');
        
        if (accessToken) {
            navigate(paths.dashboard.referAndEarn);
        } else {
            navigate('/user_login');
        }
    };
    return (
        <Fragment  >
            <Box
                sx={{
                    backgroundImage: 'url("/assets/refer&earn_bg.svg")', // Replace with the actual image URL
                    backgroundSize: "cover", // Adjust as needed
                    backgroundPosition: "center", // Adjust as needed
                    padding: { xl: '112px 61px  112px 112px', md: '112px 61px  112px 112px', xs: '93px 20px  92px 20px' },
                    zIndex: 0,
                    overflow: 'hidden',
                    backgroundColor: '#1D53E7',

                }}
            >
                <Grid
                    container
                    spacing={3}
                    sx={{ justifyContent: "center", alignContent: "center", zIndex: 1000, }}
                >
                    {mdUp && (
                        <Grid item xs={12} md={6} zIndex={2}>
                            <Typography component="span"
                                className="HeadingHeroRnE">
                                Earn Rewards up to&nbsp;<span className="HighlightedHeroRnE"  >₹1000 </span>with MegaConnect's&nbsp;<span className="HighlightedHeroRnE"  > <br />Refer and Earn </span> Program!
                            </Typography>
                            <Box justifyContent='center' alignItems='center'sx={{mt:'28px', maxWidth:'528px'}} >
                                <Typography className="heroTextRnE" >
                                    Share the benefits of a safe and high-speed cloud PC experience with your friends and family. Enjoy 50% cashback when your referral subscribes, and give them an instant 50% discount!
                                </Typography>
                            </Box>
                            <Grid
                                container
                                md={6}
                                justifyContent="center"
                                sx={{pt:'24px', pb:'20px'}}
                            >
                                <GetReferralCode
                                    variant="contained"
                                    fullWidth
                                    size="large"
                                    onClick={handleReferralClick}
                                    sx={{
                                        color: "#1E53E8",
                                        fontWeight: "bold",
                                        background: "#C7F760",
                                        padding: 1,
                                        borderRadius: 2,
                                    }}
                                >
                                    Get Your Referral Code
                                </GetReferralCode>
                            </Grid>

                        </Grid>
                    )}
                    {mdUp && <Grid item xs={12} md={6} zIndex={1} >
                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                            <img
                                src="/assets/ReferAndEarn-Hero-Illustration.svg"
                                alt="hero_header"
                                style={{ maxWidth: "100%", height: 'auto', objectFit: 'fill' }}

                            />
                        </Box>
                    </Grid>}
                    {!mdUp && <Grid item xs={12} md={6} textAlign="center" justifyContent='space-between' alignContent='space-between'>
                        <Typography component="span"
                            className="HeadingHeroRnE" textAlign={'center'} >
                            Earn Rewards up to&nbsp;<span className="HighlightedHeroRnE"  >₹1000 </span>with MegaConnect's
                            &nbsp;<span className="HighlightedHeroRnE"  > Refer and Earn </span> Program!
                        </Typography>
                        <Box sx={{ display: "flex", justifyContent: "center", pb: '28px', pt: '28px' }}>
                            <img
                                src="/assets/ReferAndEarn-Hero-Illustration.svg"
                                alt="hero_header"
                                style={{ maxWidth: "100%", height: 'auto', objectFit: 'fill' }}

                            />
                        </Box>
                    </Grid>}
                    {!mdUp && (
                        <Grid item xs={12} md={7} textAlign="center" justifyContent='space-between' alignContent='space-between' >

                            <Box sx={{
                                // mt: '18px',
                                minHeight: '106px', // Set a minimum height for the Box
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                pb: '28px'
                            }}  >
                                <Typography textAlign='center' className="heroTextRnE" >
                                    Share the benefits of a safe and high-speed cloud PC experience with your friends and family. Enjoy 50% cashback when your referral subscribes, and give them an instant 50% discount!
                                </Typography>
                            </Box>
                            <Grid
                                container
                                md={4}
                                justifyContent="center"
                            >
                                <GetReferralCode
                                    variant="contained"
                                    fullWidth
                                    size="large"
                                    onClick={handleReferralClick}
                                    sx={{
                                        color: "#1E53E8",
                                        fontWeight: "bold",
                                        background: "#C7F760",
                                        padding: 1,
                                        borderRadius: 2,
                                    }}
                                >
                                    Get Your Referral Code
                                </GetReferralCode>
                            </Grid>
                        </Grid>
                    )}
                </Grid>
            </Box>
        </Fragment>
    )
}

export default ReferAndEarnHero
